<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="schemeList" v-model="filters.scheme" :label="labels.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="labels.scheme" :error-messages="errors.collect('scheme')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="polTypeList" v-model="filters.polType" :label="labels.polType" item-text="label" item-value="value" data-vv-name="polType" :data-vv-as="labels.polType" :error-messages="errors.collect('polType')" clearable></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew">
            New Policy Type<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.scheme }}</td>
                <td class="text-xs-left">{{ row.item.schemeDesc }}</td>
                <td class="text-xs-left">{{ row.item.polType }}</td>
                <td class="text-xs-left">{{ row.item.polTypeDesc }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.effDate) }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.expDate) }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery" review @review="doReview" remove @remove="doPromptRemove"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Please confirm deletion of this records. ( {{ selectedPolTypeScheme.scheme + ', ' + selectedPolTypeScheme.polType }} )
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Scheme', align: 'left', value: 'scheme' },
        { text: 'Scheme Description', value: 'schemeDesc' },
        { text: 'Policy Type', align: 'left', value: 'polType' },
        { text: 'Policy Type Description', value: 'polTypeDesc' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        scheme: 'Scheme',
        polType: 'Policy Type'
      },
      filters: {
        scheme: null,
        polType: null
      },
      schemeList: [],
      polTypeList: [],
      loading: false,
      promptRemove: false,
      selectedPolTypeScheme: {},
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    if (this.$store.state.pkgParam.polTypeScheme.init !== 1) {
      await this.$store.dispatch('polTypeSchemeInit')
    }
    this.doInit(true)
    this.getSchemeList()
    this.getPolTypeList()
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.polTypeScheme.menu
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getPolTypeSchemePage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((polTypeScheme) => {
                const convertList = {
                  scheme: polTypeScheme.scheme,
                  schemeDesc: polTypeScheme.schemeDesc,
                  polType: polTypeScheme.polType,
                  polTypeDesc: polTypeScheme.polTypeDesc,
                  effDate: polTypeScheme.effDate,
                  expDate: polTypeScheme.expDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async getSchemeList() {
      const apiURI = this.menu.getSchemeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.schemeList = []
        if (data) {
          this.schemeList = data.schemeList
        }
      }
    },
    async getPolTypeList() {
      const apiURI = this.menu.getPolTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.polTypeList = []
        if (data) {
          this.polTypeList = data.polTypeList
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.scheme = null
      this.filters.polType = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doNew() {
      this.$router.push({ name: 'polTypeSchemeReview', params: { scheme: 'new', polType: 'new', isQuery: false } })
    },
    doReview(data) {
      this.$router.push({ name: 'polTypeSchemeReview', params: { scheme: data.item.scheme, polType: data.item.polType, isQuery: false } })
    },
    doQuery(data) {
      this.$router.push({ name: 'polTypeSchemeReview', params: { scheme: data.item.scheme, polType: data.item.polType, isQuery: true } })
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedPolTypeScheme = data.item
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.deletePolTypeScheme
      if (apiURI) {
        const expand = this.selectedPolTypeScheme
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            this.message(data)
          })
      }
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
